module.exports = __webpack_public_path__ + "img/echope.27ecfe2b.png";